// Edika — locale-prefix link fixup (Langify-removal replacement).
//
// Some menu items / hardcoded section links are internal URLs written WITHOUT a
// locale prefix — either relative ("/collections/...") OR absolute to our own
// domain ("https://www.edika.com/collections/..."). Shopify only auto-prefixes
// resource-backed relative links, so these drop an /en/ visitor onto the
// default-locale (FR) page. Langify rewrote them client-side; this restores that
// after Langify is removed. (Best long-term fix: make the menu items
// resource-backed in Content > Menus so they're relative + auto-localized.)
//
// Handles relative AND same-host absolute links. Idempotent. Skips the locale
// switcher (hreflang / localization form), CDN, and admin links.
// NOTE: same-host check means absolute prod-domain links can only be rewritten
// when viewed ON that domain (live/preview), not via `shopify theme dev`.
(function () {
  var match = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(\/|$)/i);
  if (!match) return; // only run on a locale-prefixed path (e.g. /en/...)
  var prefix = '/' + match[1];
  var prefixSlash = prefix + '/';
  var current = (document.documentElement.getAttribute('lang') || '').toLowerCase();

  function fix(a) {
    var href = a.getAttribute('href');
    if (!href) return;
    var isAbsolute = false, path;
    if (href.charAt(0) === '/') {
      path = href;                                  // relative internal link
    } else {
      try {
        var u = new URL(href, window.location.href);
        if (u.hostname !== window.location.hostname) return; // external host — leave alone
        isAbsolute = true;
        path = u.pathname + u.search + u.hash;       // same-host absolute link
      } catch (e) { return; }
    }
    if (path === prefix || path.indexOf(prefixSlash) === 0) return; // already prefixed
    if (path.indexOf('/cdn/') === 0 || path.indexOf('/admin') === 0) return;
    var hreflang = a.getAttribute('hreflang');       // skip locale-switcher links
    if (hreflang && hreflang.toLowerCase() !== current) return;
    if (a.closest && a.closest('.localization-form, localization-form, .shopify-localization')) return;
    a.setAttribute('href', (isAbsolute ? window.location.origin : '') + prefix + path);
  }

  function run() {
    var anchors = document.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) fix(anchors[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
